import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30a72319"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "today-is-holiday"
}
const _hoisted_3 = {
  key: 1,
  class: "today-is-saturday"
}

import { onMounted, ref, watch } from 'vue';
import { IHolidayComponent } from "@/interface/component/master/i-holiday-component";
import { isSameDay } from "date-fns";
import HolidayService from "@/service/master/HolidayService";
import { useAuthStore } from "@/store/auth";
import { useHolidayStore } from '@/store/common/holidayStore';
import { DomHandler } from 'primevue/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'XCalendarClean',
  props: {
    width: {
        type: String,
        default: ''
    },
    enableCustomizePanel: {
        type: Boolean,
        default: false
    },
    closeCustomizePanel: {
        type: Boolean,
        default: true
    },
    panelShowBottom: {
        type: String,
        default: ''
    },
    showIcon: {
        type: Boolean,
        default: true
    },
    rootElementRemoveClass: {
        type: String,
        default: ''
    },
    id: {
        type: String,
        default: ''
    },
    rootId: {
        type: String,
        default: ''
    }
},
  emits: ['show'],
  setup(__props, { emit: emits }) {

const props = __props





const authStore = useAuthStore();
const holidayStore = useHolidayStore();

const holidayService = ref(new HolidayService());

const customCalendar = ref();

const height = ref(0);

onMounted(() => {
    getHolidays();
    top.value = customCalendar.value.$el.offsetHeight/2-6;
    if (props.showIcon) {
        left.value = customCalendar.value.$el.offsetWidth-59;
    } else {
        left.value = customCalendar.value.$el.offsetWidth-21;
    }
    let id = '';
    if (props.rootId) {
        id = '#'+props.rootId;
    } else {
        id = '#x-calendar-clean';
    }
    const root = document.querySelector(id);
    if (root && root!.classList && props.rootElementRemoveClass) {
        root!.classList.remove(props.rootElementRemoveClass);
    }
    window.addEventListener('resize', handleResize);
});

watch(()=>customCalendar.value,(newVal,oldVal)=>{
    top.value = customCalendar.value.$el.offsetHeight/2-6;
    if (props.showIcon) {
        left.value = customCalendar.value.$el.offsetWidth-59;
    } else {
        left.value = customCalendar.value.$el.offsetWidth-21;
    }
},{deep:true});

const handleResize = ()=>{
    top.value = customCalendar.value.$el.offsetHeight/2-6;
    if (props.showIcon) {
        left.value = customCalendar.value.$el.offsetWidth-59;
    } else {
        left.value = customCalendar.value.$el.offsetWidth-21;
    }
}

const onFocus = () => {
    top.value = customCalendar.value.$el.offsetHeight/2-6;
    if (props.showIcon) {
        left.value = customCalendar.value.$el.offsetWidth-59;
    } else {
        left.value = customCalendar.value.$el.offsetWidth-21;
    }
}

const onBlur = (event: any) => {
    const { originalEvent } = event;

    if (originalEvent.relatedTarget && originalEvent.relatedTarget.tagName === 'INPUT') {
        customCalendar.value.overlayVisible = false;
    }
}


const getHolidays = () => {
    if (holidayStore.holidays.length === 0) {
        authStore.spinner = true;
        holidayService.value.list()
            .then(data => {
                holidayStore.holidays = data as IHolidayComponent[];
            })
            .finally(() => {
                // Hide spinner
                authStore.spinner = false;
            });
    }
}

const isHoliday = (date: any) => {

    let dateStr = date.year + '/' + (date.month + 1) + '/' + date.day;
    let holidayDate = new Date(dateStr);

    let index = holidayStore.holidays.findIndex((item) => {

        let d = new Date(item.holiday);

        return isSameDay(holidayDate, d);
    });

    return index >= 0;
}

const isSaturday = (date: any) => {
    let dateStr = date.year + '/' + (date.month + 1) + '/' + date.day;
    let holidayDate = new Date(dateStr);
    let nowDay = holidayDate.getDay();
    let weeks = ["日", "月", "火", "水", "木", "金", "土"];
    return weeks[nowDay];
}

const calendarShow = () => {
    if (props.enableCustomizePanel && !props.closeCustomizePanel) {
        customCalendar.value.$el.children[1].click();
    }

    if (props.panelShowBottom) {
        const element = document.querySelector('.'+props.panelShowBottom);
        console.log(element)
        if (element) {
            const height = customCalendar.value.$el.children[1].offsetHeight+customCalendar.value.$el.children[1].getBoundingClientRect().top
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            element.style!.top = (height+scrollTop)+'px';
        }
    }
    emits('show');
}

const top = ref(0);
const left = ref(0);

const cleanCalendarValue = () => {
    customCalendar.value.updateModel(null);
}

const cycExc = () => {
    setTimeout(() => {
        if (!customCalendar.value) {
            cycExc();
            return;
        }
        top.value = customCalendar.value.$el.offsetHeight/2-6;
        if (props.showIcon) {
            left.value = customCalendar.value.$el.offsetWidth-59;
        } else {
            left.value = customCalendar.value.$el.offsetWidth-21;
        }
        if (top.value < 0) {
            cycExc();
        }
    }, 200);
}

const xShow = (modelValue: any, disabled: any) => {
    if (modelValue && !disabled) {
        if (!customCalendar.value) {
            cycExc();
        } else {
            top.value = customCalendar.value.$el.offsetHeight/2-6;
            if (top.value < 0) {
                cycExc();
            }
            if (props.showIcon) {
                left.value = customCalendar.value.$el.offsetWidth-59;
            } else {
                left.value = customCalendar.value.$el.offsetWidth-21;
            }
        }
        return true;
    }
    return false;
}

return (_ctx: any,_cache: any) => {
  const _component_Calendar = _resolveComponent("Calendar")!

  return (_openBlock(), _createElementBlock("div", {
    style: {"position":"relative"},
    id: __props.rootId?__props.rootId:'x-calendar-clean'
  }, [
    _createVNode(_component_Calendar, _mergeProps({
      inputStyle: `font-weight: bold; font-size: 14px; ${__props.width}`,
      dateFormat: "yy/mm/dd"
    }, _ctx.$attrs, {
      showIcon: __props.showIcon,
      onFocus: onFocus,
      onBlur: onBlur,
      id: __props.id,
      ref_key: "customCalendar",
      ref: customCalendar,
      panelClass: __props.enableCustomizePanel && !__props.closeCustomizePanel ? 'global-calendar-panel' : props.panelShowBottom,
      onShow: calendarShow,
      autocomplete: "off"
    }), {
      date: _withCtx((slotProps) => [
        (isHoliday(slotProps.date) || isSaturday(slotProps.date) === '日')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("strong", null, _toDisplayString(slotProps.date.day), 1)
            ]))
          : _createCommentVNode("", true),
        (isSaturday(slotProps.date) === '土' && !isHoliday(slotProps.date))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("strong", null, _toDisplayString(slotProps.date.day), 1)
            ]))
          : _createCommentVNode("", true),
        (!isHoliday(slotProps.date) && !isSaturday(slotProps.date))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(slotProps.date.day), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16, ["inputStyle", "showIcon", "id", "panelClass"]),
    _withDirectives(_createElementVNode("span", {
      class: "pi pi-times",
      style: _normalizeStyle([{"position":"absolute"}, 'top:'+top.value+'px;'+'left:'+left.value+'px;']),
      onClick: cleanCalendarValue
    }, null, 4), [
      [_vShow, xShow(_ctx.$attrs.modelValue, _ctx.$attrs.disabled)]
    ])
  ], 8, _hoisted_1))
}
}

})